import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';
import { MenuService } from '../../../../services/menu.service';
import { TranslationService } from '../../../../services/translation.service';
import { ConfigService } from '../../../../services/config.service';
import { DataIoService } from '../../../../services/data-io.service';
import { LoadinganimationComponent } from '../loadinganimation/loadinganimation.component';
import { MenuNode, Helper } from '../../../../classes';
import { EnabledNodesPipe } from '../../../../pipes/enabled-nodes.pipe';
import { DayOverviewComponent } from '../../../helpers/day-overview/day-overview.component';
@Component({
    selector: 'screen-menu',
    templateUrl: './week-overview.component.html',
    styleUrls: ['./week-overview.component.scss'],
    standalone: false
})
export class WeekOverviewComponent implements OnInit, OnDestroy{
    @Input('debug') debug:boolean = false;

    eventSubscription:any;
    title:string;
    subtitle:string;
    template_parameters:Array<string>;
    _top:number=0;
    zone :string = undefined;
    selectedDay=0;

    constructor(
        private menuService: MenuService, 
        private ioService: DataIoService, 
        private config: ConfigService,
        private enabledNodes: EnabledNodesPipe,
        private translator:TranslationService
        ) { 

        this.debugOut("Constructing");
    }
    hasParameter(param){
        
        return this.menuService.hasParameter(param);
    }

    tr(s:string):string{
        return this.translator.tr(s);
    }
    calculateTop():void{
        let factor = 1;//this.elementsAbove(this.currentElement);
        this._top = 0;//this._initTop - (this._elementHeight * factor); 
        this.debugOut("Elements above: "+factor);
    }

  
    pans=0;
    panSkip=8;
    eventHandler(event){
        switch(event){
            case 'pandown':{

                this.pans=(++this.pans%this.panSkip);
                if(this.pans != 0){
                    return;
                }
            }
            case 'down':{
                this.selectedDay++;
                if(this.selectedDay > 6){
                    this.selectedDay = 6;
                }
                break;
            }
            case 'panup':{

                this.pans=(++this.pans%this.panSkip);
                if(this.pans != 0){
                    return;
                }
            }
            case 'up':{
                
                this.selectedDay--;
                if(this.selectedDay < 0){
                    this.selectedDay = 0;
                }
                break;
            }
            case 'confirm':{
                if(this.menuService.currentNode.hasTarget()){
                    let target = this.menuService.currentNode.getTargetNode();
                    if(target == null){
                        this.debugOut("target is null..");
                        return;
                    }
                    target.set('zone',this.zone);
                    target.set('day',this.selectedDay);

                    if(this.menuService.currentNode.isDescendantOf('schaltuhr_heizen')){
                        console.log("ignoring temperature.");
                        target.set('ignore','temperature');
                    }
                    target.set('table',this.table);

                    
                    this.menuService.goto(target);
                }
                return;
            }
            case 'back':{
                this.menuService.hierarchyUp();
                return;
                
            }
            default:{

            }
        }
    }


    applyOpacity(){
    }
    table : string;
    ngOnInit() {
        this.debugOut("onInit");
        let zoneIdentifier = this.menuService.getCurrentNode().getValue();
        let parts = Helper.split(zoneIdentifier,'.')
        let id = parts[0];
        this.table = parts[1];
        if(id == "default"){
            id = this.ioService.deviceInfo().getDefaultZoneId().toString();
        }
        this.zone = this.ioService.deviceInfo().getDefaultZoneId().toString();
        


        this.debugOut("Zone: "+this.zone);
        this.debugOut("Table: "+this.table);
        this.eventSubscription = this.ioService.inputs.events$.subscribe(
            (event)=>{this.eventHandler(event);}
        );
        this.debugOut("Planner for zone: "+this.menuService.currentNode.getValue());
    }

    ngOnDestroy(){
        this.debugOut("onDestroy");
        this.eventSubscription.unsubscribe();
        this.menuService.currentNode.run((node)=>node.removeFilter(),3);
    }
    debugOut(msg:string):void{
        if(this.debug){
            console.log("WeekOverviewComponent: "+msg);
        }
    }
    isSelected(day:number){
        return this.selectedDay == day;
    }
}
